import {Izbor} from "../../../komponente/izbor/Izbor"
import podaci from './podaci.json'
import Sneg from '../../../priroda/Sneg.js'
const sneg = new Sneg()

export default class extends Izbor {

  constructor() {
    super(podaci)
  }

  start() {
    super.start()
    sneg.start()
  }

  stop() {
    super.stop()
    sneg.stop()
  }

}



// WEBPACK FOOTER //
// ./src/hronologija/1945/01-01/Straza.js